import { create } from 'zustand'
import { teacherBalanceApi } from '@/api/teacherBalance'
import type { TeacherBalanceSummary } from '@/types/tts'

interface BalanceState {
  balance: string | null
  currency: string
  pricePerChar: string | null
  cacheDiscountPercent: number | null
  pendingTopupTotal: string | null
  loading: boolean
  error: string | null
  /** Загрузить баланс с сервера; при ошибке пробрасывает исключение */
  fetchBalance: () => Promise<void>
  /** Обновить баланс из ответа генерации/батча без перезапроса */
  applyBalance: (balance: string) => void
  clearError: () => void
}

export const useBalanceStore = create<BalanceState>((set) => ({
  balance: null,
  currency: 'RUB',
  pricePerChar: null,
  cacheDiscountPercent: null,
  pendingTopupTotal: null,
  loading: false,
  error: null,

  fetchBalance: async () => {
    set({ loading: true, error: null })
    try {
      const summary: TeacherBalanceSummary = await teacherBalanceApi.getBalance()
      set({
        balance: summary.balance,
        currency: summary.currency,
        pricePerChar: summary.price_per_char,
        cacheDiscountPercent: summary.cache_discount_percent,
        pendingTopupTotal: summary.pending_topup_total,
        loading: false,
        error: null,
      })
    } catch (err) {
      set({ loading: false })
      throw err
    }
  },

  applyBalance: (balance: string) => set({ balance }),

  clearError: () => set({ error: null }),
}))
